import {SharableEntityType} from 'common/report/util/saved-entities/types';
import {cohortsClient} from 'common/report/queries/app-api/cohorts-client';
import {cohortsStore} from 'common/report/stores/cohorts';
import {sharingWidget} from 'common/widgets/sharing';
import {promptManageCohortModal} from 'common/widgets/create-entity-modal';
import {Cohort} from 'common/query-builder/cohorts-query-builder/models/cohort';
import {SerializedCohort} from 'common/query-builder/cohorts-query-builder/models/types/serialized-cohort-types';

export async function promptSaveCohort(
  projectId: number,
  workspaceId: number,
  dataGroupId: string | undefined,
  title: string,
  isSharingEnabled: boolean,
  cohortToSave: SerializedCohort,
  onSavedCohort: (cohort: Cohort) => void,
) {
  const {didSave, name, description, clearOpenShareUponSave, event} = await promptManageCohortModal(
    title,
    {
      'show-share-management': isSharingEnabled,
      'project-id': projectId,
    },
    {
      existingEntityNames: Object.values(cohortsStore.value)
        .filter((cohort) => Number.isInteger(cohort.id))
        .map((cohort) => cohort.name?.toLowerCase()),
    },
  );

  if (!clearOpenShareUponSave && didSave) {
    const openShareOnSave = event === `saveAndShare`;

    const savedCohort = await saveCohort(
      name,
      description,
      projectId,
      workspaceId,
      dataGroupId,
      cohortToSave,
      onSavedCohort,
    );

    if (openShareOnSave) {
      await sharingWidget.promptSharing({
        type: SharableEntityType.Cohort,
        id: savedCohort.id,
        'project-id': projectId,
      });
    }
  }
}

async function saveCohort(
  name: string,
  description: string,
  projectId: number,
  workspaceId: number,
  dataGroupId: string | undefined,
  cohortToSave: SerializedCohort,
  onSavedCohort: (cohort: Cohort) => void,
) {
  const savedCohort = await cohortsClient.createCohort({
    workspaceId,
    projectId,
    cohort: {
      ...cohortToSave,
      name,
      description,
    },
  });

  // if something went wrong
  if (savedCohort.id === undefined) {
    throw new Error(`cohort has no id ${JSON.stringify(savedCohort)}`);
  } else {
    const cohortId = savedCohort.id;

    const cohort = Cohort.createUsersInCohort({cohortId, dataGroupId: dataGroupId || undefined});
    cohortsStore.update({[cohortId]: {...savedCohort, count: undefined}});
    onSavedCohort(cohort);

    return savedCohort;
  }
}
